import { NextPage } from "next";
import { Seo } from "~/components/seo";
import { SplashScreen } from "~served/ui-comps/components/splash-screen";

const HomePage: NextPage = () => {
	return (
		<>
			<Seo title="Redirecting..." />
			<SplashScreen />
		</>
	);
};

export default HomePage;
